import "./AccountMobileAppBarStyle.css";

import React, { FC } from "react";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";
import { styled } from "@mui/material/styles";

export interface IAccountMobileAppBar {
    toolbarMenuContent?: React.ReactNode;
    appBarHeader?: React.ReactNode;

}

interface StyledAppBarProps {
    children?: React.ReactNode;
}

const StyledAppBar = styled((props: StyledAppBarProps) => {

    return <AppBar {...props} />;
})(
    ({ theme }: any) => `
  background-color: #0091b3;
  padding:0;
  color: #ffffff;
  width: "100%";
  z-index:3!important;
  // box-shadow:0px 2px 4px -1px rgba(0,0,0,0),0px 4px 5px 0px rgba(0,0,0,0.05),0px 1px 10px 0px rgba(0,0,0,0);
  box-shadow:none;
  :hover {
    color: ${(theme.palette.primary.main, 0.2)};
  }
`
);

export const AccountMobileAppBar: FC<IAccountMobileAppBar> = ({
    toolbarMenuContent,
    appBarHeader,
}: IAccountMobileAppBar) => {
    return (
        <StyledAppBar >
            <Toolbar sx={{ padding: "0 15px !important" }}>
                <Typography sx={{ pt: "5px" }}>
                    {appBarHeader}
                </Typography>
                {/* <Box sx={{ width: "100%" }}>
                    <div style={{ flexGrow: 20 }} />
                    {toolbarMenuContent}
                </Box>
                <Box>
                    <i
                        className={"pi pi-sign-out"}
                        onClick={() => navigate("/logout")}
                        style={{ cursor: "pointer", marginLeft: "1rem" }}
                    />
                </Box> */}
            </Toolbar>
        </StyledAppBar>
    );
};
